import React from "react";
import "../../global.scss";
import "./addVehicle.scss";

import { IonRow, IonCol, IonText, IonLabel, IonModal, IonInput, IonButton } from "@ionic/react";
import {
  LAST_SERVICE,
  ODOMETER,
  ADD_ANOTHER_VEHICLE,
  CHOOSE_FROM,
  THREE_THOUSAND_PLUS,
  MODELS,
  ADD_VEHICLE,
  SELECT_YOUR_VEHICLE,
  SEARCH_FOR_VEHICLE,
} from "../../constants";
import * as constants from "../../constants";
import { connect } from "react-redux";
import { COLLECTIONS } from "../../firebase";
import {
  setSelectedVehicle,
  saveCatelogVehicleId,
  deleteCartItemList,
  getCartItemsList,
} from "../../Store/Actions";

const PopUpVehicles: React.FC = (props: any) => {
  const [showCarVehicles, setCarVehicles] = React.useState(false);
  const [showVehicleModal, setShowVehicleModal] = React.useState(false);
  const [state, setState] = React.useState("");
  const [carReg, setCarReg] = React.useState({
    model: "",
    reg: "",
  });
  const [searchVehicles, setSearchVehicles] = React.useState("");
  React.useEffect(() => {
    setState((props.selectedVehicleRef || "").split("/").pop());
    if (props.onBoarding) {
      const data =
        props.userVehiclesList.length &&
        props.userVehiclesList.find(
          (ele: any) => ele.did === (props.selectedVehicleRef || "").split("/").pop(),
        );
      setCarReg({
        model: !!data ? data.model : "",
        reg:
          !!data && data.registrationNumber
            ? data.registrationNumber.slice(data.registrationNumber.length - 4)
            : "",
      });
      setCarVehicles(false);
    }
    return () => {
      setState("");
    };
  }, [props.selectedVehicleRef, props.userVehiclesList]);
  const setSelectedVehicleRef = async (vehicleId: any) => {
    const data: any = (props.userVehiclesList.find((ele: any) => ele.did === vehicleId) || {})
      .catalogVehicleId;
      
    setState(vehicleId);
    await props.setSelectedVehicle(
      `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${vehicleId}`,
    );
    await props.saveCatelogVehicleId(data);
  };

  const handleSearch = (data: Array<any>) => {
    if (!!searchVehicles) {
      return data.filter((ele: any) => {
        const result = Object.values(ele)
          .map((ele: any) => typeof ele === "string" && ele.toLowerCase())
          .filter((e: any) => e)
          .join(" ")
          .toLowerCase();
        if (result.includes(searchVehicles.toLowerCase())) {
          return ele;
        }
      });
    }
    return data;
  };
  return (
    <>
      <div
        className={
          props.mainHeader === constants.CONFIRMATION
            ? "confirm_modal_car_img"
            : props.history.location.pathname.includes(`/portal/dashboard`)
            ? "carimg_container dashboard_res car_img_left_space"
            : "carimg_container car_img_left_space"
        }
        onClick={() =>
          !!props.confirmScreen && (props.cart_items || []).length
            ? setShowVehicleModal(true)
            : setCarVehicles(true)
        }
      >
        <img src="/images/carImg.svg" />
        {carReg.model.length > 0 && (
          <div className="carnmodel_text_container">
            <IonLabel className="carnmodel_text">{`${carReg.model} ${carReg.reg}`}</IonLabel>
          </div>
        )}
      </div>
      <IonModal
        isOpen={showCarVehicles}
        backdropDismiss={true}
        onDidDismiss={() => {
          setSearchVehicles("");
          setCarVehicles(false);
        }}
      >
        <div className="modal_body">
          <div className="modal_panel">
            <IonText className="modal_header vehicle_header font_size_20">
              {SELECT_YOUR_VEHICLE}
            </IonText>
            <img
              className="close_icon"
              onClick={() => {
                setSearchVehicles("");
                setCarVehicles(false);
              }}
              src="/images/close_popup.svg"
            />
          </div>
          <div className="search_brand">
            <IonInput
              className="input_search"
              placeholder={SEARCH_FOR_VEHICLE}
              value={searchVehicles}
              autofocus={false}
              onIonChange={(e: any) => setSearchVehicles(e.detail.value)}
            />
            <img className="search_web" src="/images/search-icon.svg" />
            <img className="search_res" src="/images/search_res.svg" />
          </div>
          <div className="personal_details_text my_vehicles pop_scroll margin-bottom-0">
            <div className="personal_details_div">
              <IonRow>
                {handleSearch(props.userVehiclesList).length
                  ? handleSearch(props.userVehiclesList).map((ele: any, index: any) => (
                      <IonCol
                        className={
                          ele.did === props.selectedVehicleRef.split("/").pop()
                            ? "my_vehicles_body selected_color"
                            : "my_vehicles_body popup_bg"
                        }
                        key={index}
                        size-md="5"
                        size="12"
                        onClick={() => setSelectedVehicleRef(ele.did)}
                      >
                        <div>
                          <IonLabel
                            className="vehicle_name"
                            color={
                              ele.did === props.selectedVehicleRef.split("/").pop()
                                ? "light"
                                : "tertiary"
                            }
                          >
                            {ele.model} {ele.make}
                          </IonLabel>
                          <IonText
                            className="vehicle_year"
                            color={
                              ele.did === props.selectedVehicleRef.split("/").pop()
                                ? "light-grey"
                                : "tertiary"
                            }
                          >
                            {ele.year}
                            {","} {ele.fuelType}
                          </IonText>
                        </div>
                        <div className="my_vehicles_car_details">
                          <img src={ele.imageUrl} className="vehicle_img" />
                        </div>
                      </IonCol>
                    ))
                  : !!searchVehicles.trim().length && (
                      <div className="no-search-results">
                        <h2 color="secondary">{"No vehicles found"}</h2>
                      </div>
                    )}
              </IonRow>
            </div>
            <div className="personal_details_div add_my_vehicle">
              <IonRow>
                <IonCol
                  className="my_vehicles_body add_vehicle_body popup_bg"
                  color="light"
                  size-md="5"
                  size="12"
                  onClick={() => {
                    props.history.push("/portal/add-vehicles");
                    setCarVehicles(false);
                  }}
                >
                  <div>
                    {props.userVehiclesList.length ? (
                      <IonLabel className="add_my_vehicle_text" color="primary">
                        {ADD_ANOTHER_VEHICLE}
                      </IonLabel>
                    ) : (
                      <IonLabel className="add_my_vehicle_text" color="primary">
                        {ADD_VEHICLE}
                      </IonLabel>
                    )}

                    <IonLabel className="choose_models">
                      {CHOOSE_FROM}
                      <span className="models_plus">{THREE_THOUSAND_PLUS}</span> {MODELS}
                    </IonLabel>
                  </div>
                  <div className="add_img">
                    <img src="/images/add-vehicle.svg" />
                  </div>
                </IonCol>
              </IonRow>
            </div>
          </div>
        </div>
      </IonModal>
      <IonModal isOpen={showVehicleModal} backdropDismiss={false} cssClass="modalRoot">
        <div className="changeVehRoot">
          <IonLabel className="changeVehicle">{constants.CHANGE_VEHICLE}</IonLabel>
          <IonLabel className="changeVehCon">{constants.CHANGE_VEHICLE_CONFIRM}</IonLabel>
          <IonLabel className="changeVehCon">{constants.SERVICES_WILL_LOST}</IonLabel>
          <div className="confirmButtons">
            <IonButton
              fill="outline"
              className="conbtns"
              onClick={() => setShowVehicleModal(false)}
            >
              <IonLabel className="modalNo">{constants.NO}</IonLabel>
            </IonButton>
            <IonButton
              fill="outline"
              className="conbtns"
              onClick={async () => {
                await props.deleteCartItemList();
                props.closeConfirm();
                setShowVehicleModal(false);
              }}
            >
              <IonLabel className="modalNo">{constants.YES}</IonLabel>
            </IonButton>
          </div>
        </div>
      </IonModal>
    </>
  );
};

export default connect(({ auth, userInfo }: any) => ({ ...auth, ...userInfo }), {
  setSelectedVehicle,
  saveCatelogVehicleId,
  deleteCartItemList,
  getCartItemsList,
})(PopUpVehicles);
